import React, { Component } from 'react';
import {Col, Row} from 'reactstrap'

export default class ChatMessage extends Component {

    containerStyle() {    
        return {
          backgroundColor: this.props.message.isSender ? '#20A8D8' : 'lightgray',
          float: this.props.message.isSender ? 'right' : 'left',
          alignSelf: this.props.message.isSender ? 'flex-end' : 'flex-start',
          padding: 8,
          borderRadius: 10,
          overflowWrap: "break-word",
          display: "inline-block"
        };
    }
    
    textStyle() {
        return {
          fontSize: 14,
          color: this.props.message.isSender ? 'white' : 'black',
          marginBottom: "0px"
        };
    }

    formatMessage(){
        if(this.props.message.isSender){
            return this.getUserMessageRow()
        } else {
            return this.getBotMessageRow()
        }
    }

    getUserMessageRow(){
        return [
            <Col xs="2" key="1">
            </Col>,
            <Col xs="10" key="2">
                <div style={this.containerStyle()}>
                    <p style={this.textStyle()}>{this.props.message.text}</p>
                </div>
            </Col>
        ]
    }

    getBotMessageRow(){
        return [
            <Col xs="10" key="1">
                <div style={this.containerStyle()}>
                    <p style={this.textStyle()}>{this.props.message.text}</p>
                </div>
            </Col>,
            <Col xs="2" key="2">
            </Col>
        ]
    }

    render(){
        return (
        <Row>
            {this.formatMessage()}
        </Row>
        )
    }
}
